import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {

    updateLicenseInfo(data) {
        return axios.post(constants.BASE_URL + "/license-info", data).then(response => {
            return response.data;

        }).catch(error => {
            return error.response;
        }); 
    },
    getLicenseInfo() {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/license-info").then(response => {
            return response.data;

        }).catch(error => {
            return error.response;
        }); 
    }
}
